import gql from 'graphql-tag';

export const getProgressiveCertifications = gql`
  query GetProgressiveCertifications(
    $carrer: String!
    $prog: String!
    $acadPlan: String!
  ) {
    getProgressiveCertifications(
      carrer: $carrer
      prog: $prog
      acadPlan: $acadPlan
    ) {
      certificationId
      certificateCode
      certificationName
      state
      message
      courses {
        courseId
        courseName
        finalGrade
        state
      }
    }
  }
`;
